<div class="snack-bar" [ngClass]="{'snack-bar--error' : snackBarTheme === SnackBarTheme.Error }" (click)="close()">
    <span class="snack-bar__message">
        {{message}}
    </span>
</div>